import React, { ReactNode } from 'react';
import styles from './assets/substitution-screen.module.scss';
import classNames from 'classnames';
import SubstitutionsGrid from './components/SubstitutionsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateSubstitutionButton from './components/CreateSubstitutionButton';

import { ISubstitution } from 'src/types/substitution';
import AdminLayout from '../../../../../../components/layout/RoleLayout';

export interface StateProps {
    data: Paginated<ISubstitution>;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class SubstitutionsList extends React.Component<Props> {
    //componentDidMount() {}

    public render(): ReactNode {
        const { data, getData } = this.props;

        return (
            <AdminLayout>
                <div className={`${classNames('pageHeading')}`}>
                    <h2 className={`${classNames('pageHeadingTitle')}`}>SUBSTITUTIONS</h2>
                    <CreateSubstitutionButton />
                </div>
                <div className={classNames(styles.list)}>
                    <SubstitutionsGrid data={data} getData={getData} />
                </div>
            </AdminLayout>
        );
    }
}

export default SubstitutionsList;
